import { InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledSearchField = styled(InputBase)(({ theme }) => ({
	minHeight: 48,
	paddingInline: theme.spacing(theme.spacingTokens.lg),
	backgroundColor: theme.palette.grey[50],
	border: `1px solid ${theme.palette.grey[200]}`,
	borderRadius: theme.radii.lg,
	transition: "border-color 150ms, box-shadow 150ms",
	"&.Mui-focused": {
		borderColor: theme.palette.blue[300],
		boxShadow: `0 0 0 2px ${theme.palette.blue[100]}`,
	},
	"& input": {
		padding: 0,
		fontSize: theme.typography.body2.fontSize,
		color: theme.palette.text.primary,
		"&::placeholder": {
			color: theme.palette.grey[400],
			opacity: 1,
		},
	},
}));
